import Icon from '@components/common/Icon';

const milestones = [
  {
    year: '2023',
    title: 'National Master Title',
    description: 'Earned the prestigious National Master title, recognizing consistent high-level performance in competitive chess.',
    highlight: true
  },
  {
    year: '2024',
    title: 'National Chess Champion - Dapitan',
    description: 'Won the National Chess Championship in Dapitan, competing against top players from across the Philippines.',
    highlight: true
  },
  {
    year: '2024',
    title: 'Under-16 National Champion',
    description: 'Secured the Under-16 National Championship title, demonstrating dominance in the youth category.',
    highlight: false
  },
  {
    year: '2025',
    title: 'PAREF Southridge Chess Champion',
    description: 'Recognized as the PAREF Southridge Chess Champion, showcasing excellence at the school level.',
    highlight: false
  },
  {
    year: '2022',
    title: 'Second Runner Up - Malolos',
    description: 'Achieved Second Runner Up in Malolos in the national championship tournament.',
    highlight: false
  },
  {
    year: '2019',
    title: 'Thailand International Champion',
    description: 'Won the international chess tournament in Thailand, competing against players from multiple countries.',
    highlight: false
  },
  {
    year: '2019',
    title: 'National Champion',
    description: 'Multiple National championship titles, establishing consistent performance across various tournaments.',
    highlight: false
  },
  {
    year: '2018',
    title: 'China International Tournament Victory',
    description: 'Emerged victorious in the Shanghai international tournament, demonstrating skill on the global stage.',
    highlight: false
  },
  {
    year: '2018',
    title: 'India State Level Tournament Victory',
    description: 'Won multiple state level tournaments in the West Bengal State of India including the prestigious Telegraph Schools Chess Championship in Gorky Sadan, Kolkata.',
    highlight: false
  },
  {
    year: '2016',
    title: 'Thailand ASEAN+ International Championship',
    description: 'Achieved Runner Up in the international championship tournament in Pattaya, Thailand.',
    highlight: false
  }
];

const AchievementsSection = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: 'var(--color-body-bg)' }}>
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold mb-4"
            style={{ color: 'var(--color-heading)' }}
          >
            Tournament Milestones
          </h2>
          <p
            className="text-lg max-w-2xl mx-auto"
            style={{ color: 'var(--color-subtle)' }}
          >
            A journey of competitive excellence spanning national and international chess tournaments.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div
            className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 hidden lg:block"
            style={{ backgroundColor: 'var(--color-border-medium)' }}
          ></div>

          {/* Timeline items */}
          <div className="space-y-12">
            {milestones.map((milestone, index) => (
              <div
                key={index}
                className={`relative flex flex-col lg:flex-row gap-8 items-center ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
              >
                {/* Content card */}
                <div className="w-full lg:w-5/12">
                  <div
                    className={`p-5 sm:p-6 rounded-xl border transition-all duration-300 hover:shadow-card-hover ${
                      milestone.highlight ? 'shadow-card-hover' : 'shadow-card'
                    }`}
                    style={{
                      backgroundColor: 'var(--color-card-bg)',
                      borderColor: milestone.highlight
                        ? 'var(--color-accent-6)'
                        : 'var(--color-card-border)',
                      borderWidth: milestone.highlight ? '2px' : '1px'
                    }}
                  >
                    {milestone.highlight && (
                      <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full mb-4" style={{ backgroundColor: 'var(--color-accent-1)' }}>
                        <span className="text-xs font-bold" style={{ color: 'var(--color-accent-7)' }}>
                          MAJOR ACHIEVEMENT
                        </span>
                      </div>
                    )}
                    <div className="flex items-start gap-3 mb-3">
                      <div
                        className="px-2.5 sm:px-3 py-1 rounded-lg text-xs sm:text-sm font-bold flex-shrink-0"
                        style={{
                          backgroundColor: milestone.highlight
                            ? 'var(--color-accent-6)'
                            : 'var(--color-theme-2)',
                          color: milestone.highlight
                            ? 'var(--color-button-primary-text)'
                            : 'var(--color-muted)'
                        }}
                      >
                        {milestone.year}
                      </div>
                      <h3
                        className="text-lg sm:text-xl font-bold flex-1"
                        style={{ color: 'var(--color-heading)' }}
                      >
                        {milestone.title}
                      </h3>
                    </div>
                    <p
                      className="text-sm sm:text-base leading-relaxed"
                      style={{ color: 'var(--color-card-text)' }}
                    >
                      {milestone.description}
                    </p>
                  </div>
                </div>

                {/* Center dot */}
                <div className="hidden lg:flex items-center justify-center flex-shrink-0">
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center z-10"
                    style={{
                      backgroundColor: milestone.highlight
                        ? 'var(--color-accent-6)'
                        : 'var(--color-card-bg)',
                      borderColor: milestone.highlight
                        ? 'var(--color-accent-6)'
                        : 'var(--color-border-medium)',
                      borderWidth: '3px',
                      borderStyle: 'solid'
                    }}
                  >
                    {milestone.highlight && (
                      <Icon
                        name="chess"
                        size="md"
                        style={{ color: 'var(--color-button-primary-text)' }}
                      />
                    )}
                  </div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="hidden lg:block lg:w-5/12"></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AchievementsSection;
